module.exports = __webpack_public_path__ + "asset/agm-proxy-pdf--fcceb1.png";